import { render } from "./AddRoadWarrant.vue?vue&type=template&id=384bef97"
import script from "./AddRoadWarrant.vue?vue&type=script&lang=js"
export * from "./AddRoadWarrant.vue?vue&type=script&lang=js"
script.render = render

export default script